import { cn } from "../../lib/utils";
import { forwardRef } from "react";

const Select = forwardRef(
  ({ label, name, options = [], error, className, ...rest }, ref) => {
    return (
      <div className="space-y-1">
        {label && (
          <label
            htmlFor={name}
            className="block text-sm font-medium text-slate-700"
          >
            {label}
          </label>
        )}
        <select
          ref={ref}
          id={name}
          name={name}
          className={cn(
            "w-full border border-slate-300 rounded-lg px-3 py-2 text-sm",
            "focus:outline-none focus:ring-2 focus:ring-carex-500 focus:border-carex-500",
            "transition-colors duration-200 bg-white",
            error && "border-red-500 focus:ring-red-500 focus:border-red-500",
            className
          )}
          {...rest}
        >
          <option value="">-- Sélectionner --</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {error && <p className="text-sm text-red-600">{error}</p>}
      </div>
    );
  }
);

Select.displayName = "Select";

export default Select;
